export default "__VITE_ASSET__BTOhPMv___"